/**
 * "Add a note" on an appointment whose date has passed and that carries
 * no note yet (appointmentAwaitsNote): it opens the row's edit form,
 * where Notes is a box of many lines. Shown to a viewer who may edit the
 * record, as the row's own Edit is.
 */
import { useState, type ReactNode } from 'react';
import { Button } from '@/components/primitives/Button';
import { RowEditDialog } from '@/components/clientRecord/RowEditDialog';
import { canWriteClinicalRecord } from '@/lib/capabilities';
import { useTenant } from '@/lib/auth';

export function AppointmentAddNote({ rowId, values }: { rowId: string; values: Record<string, unknown> }): ReactNode {
  const [open, setOpen] = useState(false);
  const canWrite = canWriteClinicalRecord(useTenant().whoami);
  if (!canWrite) return null;
  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        className="!min-h-0 !px-1.5 !py-0.5 text-xs"
        data-testid={`appointment-add-note-${rowId}`}
        onClick={() => setOpen(true)}
      >
        Add a note
      </Button>
      {open && <RowEditDialog projection="appointments" rowId={rowId} values={values} onClose={() => setOpen(false)} />}
    </>
  );
}
